(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[886],{

/***/ 82625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31198);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77868);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66714);
/* harmony import */ var _business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82090);
/* harmony import */ var _business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11565);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_6__);








let debounceTimeout;
const BusinessHeaderAutoCompleteList = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .useLocale */ .bU)();
    const { isShown , onClickButtonSearch , onClose , onFocus , onSearch  } = props;
    const [searchSuggestions, setSearchSuggestions] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [showSuggestions, setShowSuggestions] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [inputSearchValue, setInputValueSearch] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        let cancelled = false;
        if (inputSearchValue) {
            setShowSuggestions(true);
            onSearch === null || onSearch === void 0 ? void 0 : onSearch();
        }
        if ((0,dompurify__WEBPACK_IMPORTED_MODULE_6__.sanitize)(inputSearchValue) !== inputSearchValue) {
            setSearchSuggestions({
                categories: [],
                articles: []
            });
            return;
        }
        setSearchSuggestions(undefined);
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
            debounceTimeout = undefined;
        }
        debounceTimeout = setTimeout(()=>{
            if (!inputSearchValue) return;
            (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_3__/* .getQuickSearchResponses */ .Af)(locale, inputSearchValue).then((suggestions)=>{
                if (!cancelled) {
                    setSearchSuggestions(suggestions);
                }
            });
        }, 400);
        return ()=>{
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }
            cancelled = true;
        };
    }, [
        inputSearchValue
    ]);
    const handleChangeInputSearch = (e)=>{
        setInputValueSearch(e.currentTarget.value);
    };
    const freeTextSearchTargetLink = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .localifyLink */ .Bj)("/".concat(locale, "/business/resources/search/?q=").concat(encodeURIComponent(inputSearchValue)), locale);
    const renderSuggestionsListComponent = ()=>{
        if (!showSuggestions || !inputSearchValue) {
            return null;
        }
        const renderResultsFor = (name, items)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionCategoryGroup),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionCategoryTitle),
                        children: [
                            "Results for ",
                            name
                        ]
                    }),
                    items === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().spinnerLoadMore)
                    }) : !!items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionCategoryList),
                        children: items.map((item)=>{
                            const searchMatch = new RegExp(inputSearchValue, "i");
                            const regexMatch = item.name.match(searchMatch);
                            const targetMatch = regexMatch ? regexMatch[0] : inputSearchValue;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .replaceOrAddLocale */ .yM)(item.link, locale),
                                    target: "_self",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.Search */ .T.Search
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionCategoryListText),
                                            dangerouslySetInnerHTML: {
                                                __html: (0,dompurify__WEBPACK_IMPORTED_MODULE_6__.sanitize)(item.name.replace(targetMatch, '<span class="'.concat((_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionMatch), '">').concat(targetMatch, "</span>")), {
                                                    ALLOWED_TAGS: [
                                                        "span"
                                                    ]
                                                })
                                            }
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionCategoryNoneFound),
                        children: [
                            "No ",
                            name,
                            " found"
                        ]
                    })
                ]
            });
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().suggestionsContainer),
            children: [
                renderResultsFor("Categories", searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.categories),
                renderResultsFor("Articles", searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.articles),
                renderResultsFor("Word", [
                    {
                        name: inputSearchValue,
                        link: freeTextSearchTargetLink,
                        id: ""
                    }
                ])
            ]
        });
    };
    const onKeyUp = (e)=>{
        if (e.code === "Enter" || e.code === "NumpadEnter") {
            router.push(freeTextSearchTargetLink);
        }
        if (e.code === "Escape" && onClose) {
            onClose();
            setInputValueSearch("");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formSearchBlog) + " " + (isShown ? (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formShown) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().buttonSearch) + " " + (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().clicked),
                onClick: onClickButtonSearch,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.Search */ .T.Search
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "text",
                placeholder: "eg: SEO",
                onChange: handleChangeInputSearch,
                value: inputSearchValue,
                className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inputSearch),
                onKeyUp: onKeyUp,
                onFocus: onFocus,
                onBlur: ()=>{
                    if (!inputSearchValue && onClose) {
                        onClose();
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().clearInput) + " " + (isShown ? (_business_header_autocomplete_list_module_scss__WEBPACK_IMPORTED_MODULE_7___default().formShown) : ""),
                onClick: onClickButtonSearch,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    type: _icons__WEBPACK_IMPORTED_MODULE_5__/* .IconType.RemoveCircle */ .T.RemoveCircle
                })
            }),
            renderSuggestionsListComponent()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessHeaderAutoCompleteList);


/***/ }),

/***/ 41519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./components/dropdown-selector/dropdown-selector.module.scss
var dropdown_selector_module = __webpack_require__(68099);
var dropdown_selector_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_selector_module);
;// CONCATENATED MODULE: ./components/dropdown-selector/dropdown-selector.tsx





const Dropdown = (props)=>{
    const { defaultValue , dropdownData , onChange  } = props;
    const [isDropdownOpen, setOpen] = (0,react.useState)(false);
    const [selectedItem, setSelectedItem] = (0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id) || dropdownData[0].id);
    if (!dropdownData) {
        return null;
    }
    const handleItemClick = (id)=>{
        selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
        setOpen(!isDropdownOpen);
        if (onChange) {
            const selectedItem1 = dropdownData.find((item)=>item.id === id);
            onChange(selectedItem1);
        }
    };
    const classDropdownWrapper = classnames_default()({
        "dropdown-warpper": true
    });
    const classDropdownHeader = classnames_default()({
        "dropdown-header": true,
        "dropdown-open": isDropdownOpen
    });
    const classDropdownBody = classnames_default()({
        "dropdown-body": true,
        "dropdown-open": isDropdownOpen
    });
    const classIconRight = classnames_default()({
        "icon-right": true,
        "icon-open": isDropdownOpen
    });
    const renderDefaultItem = (selectedItem)=>{
        if (selectedItem) {
            const defaultItem = dropdownData.find((item)=>item.id == selectedItem);
            return defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.label;
        } else return dropdownData[0].label;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (dropdown_selector_module_default()).dropdownSelector + " " + classDropdownWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classDropdownHeader,
                onClick: ()=>setOpen(!isDropdownOpen),
                children: [
                    renderDefaultItem(selectedItem),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classIconRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classDropdownBody,
                onClick: ()=>setOpen(false),
                children: [
                    ...dropdownData || []
                ].map((item)=>{
                    if (item.id !== selectedItem) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dropdown-item",
                            id: item.id.toString(),
                            onClick: (e)=>handleItemClick(e.target.id),
                            children: item.label
                        }, item.id);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var dropdown_selector = (Dropdown);

// EXTERNAL MODULE: ./components/business-footer/business-footer.module.scss
var business_footer_module = __webpack_require__(59411);
var business_footer_module_default = /*#__PURE__*/__webpack_require__.n(business_footer_module);
// EXTERNAL MODULE: ./models/core-site/WebFooterModel.ts + 1 modules
var WebFooterModel = __webpack_require__(97670);
;// CONCATENATED MODULE: ./components/business-footer/business-footer.tsx









const renderSingleBlock = (footerCategoryItems)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (business_footer_module_default()).footerBlock,
        children: footerCategoryItems.map((item, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: item.isLead ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_footer_module_default()).footerTitle,
                    children: item.title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.link,
                    target: "_self",
                    children: item.title
                })
            }, "footer_item_".concat(index));
        })
    });
};
const BusinessFooter = (props)=>{
    var ref;
    const { footerData , theme ="black" , hideLogo  } = props;
    const route = (0,router.useRouter)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [footerItems, setFooterItems] = (0,react.useState)(footerData !== null && footerData !== void 0 ? footerData : {
        global: [],
        regional: []
    });
    (0,react.useEffect)(()=>{
        if (!footerData) {
            let cancelled = false;
            WebFooterModel/* default.getPageFooter */.Z.getPageFooter(locale).then((items)=>{
                if (!cancelled) {
                    setFooterItems(items);
                }
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, []);
    const handleOnLocationChange = (location)=>{
        if (!location) return;
        const locale = location.id;
        const oldLocale = (0,LangHelper/* getLocaleFromRoute */._y)(route.asPath);
        let newUrl = route.asPath.replace(oldLocale, locale);
        if (newUrl.indexOf(locale) < 0) {
            newUrl = (0,LangHelper/* replaceOrAddLocale */.yM)(newUrl, locale);
        }
        var _urlRedirect;
        window.location.href = (_urlRedirect = location.urlRedirect) !== null && _urlRedirect !== void 0 ? _urlRedirect : newUrl;
    };
    const dropdownOptions = LangHelper/* LIVE_LOCALES.map */.Fw.map((thisLocale, index)=>{
        var ref;
        let origin = "";
        if (true) {
            var ref1;
            origin = ((ref1 = LangHelper/* LOCALE_LINKS */.kV[thisLocale]) === null || ref1 === void 0 ? void 0 : ref1.host) || "";
        }
        let urlRedirect = "".concat(origin, "/").concat(thisLocale, "/").concat((ref = LangHelper/* LOCALE_LINKS */.kV[thisLocale]) === null || ref === void 0 ? void 0 : ref.businessRoot);
        return {
            id: thisLocale,
            label: (0,LangHelper/* getLocalePrettyName */.FZ)(thisLocale),
            urlRedirect
        };
    });
    const getDefaultLocaleOption = ()=>dropdownOptions.find((option)=>option.id === locale);
    if (!footerItems || footerItems.global.length < 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((business_footer_module_default()).articleFooterContainer, (business_footer_module_default())["theme".concat(theme)]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_footer_module_default()).articleFooterInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_footer_module_default()).footerTop,
                    children: [
                        footerItems.global.map((item, index)=>{
                            const links = [
                                {
                                    title: item.title,
                                    isLead: true
                                },
                                ...item.links || []
                            ];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: renderSingleBlock(links)
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (business_footer_module_default()).footerLocation,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (business_footer_module_default()).footerTitle,
                                    children: "Location"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_selector, {
                                    defaultValue: getDefaultLocaleOption(),
                                    dropdownData: dropdownOptions,
                                    onChange: handleOnLocationChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (business_footer_module_default()).footerBottom,
                    children: footerItems.regional.map((item, index)=>{
                        const leadItem = {
                            title: item.title,
                            isLead: true
                        };
                        const links = [
                            {
                                title: item.title,
                                isLead: true
                            },
                            ...item.links || []
                        ];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: renderSingleBlock(links)
                        }, index);
                    })
                }),
                hideLogo ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: (ref = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref === void 0 ? void 0 : ref.home,
                    target: "_self",
                    className: (business_footer_module_default()).logoAfterPay,
                    children: locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.LogoClearpay */.T.LogoClearpay
                    }, Math.random()) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.AfterPay */.T.AfterPay
                    }, Math.random())
                })
            ]
        })
    });
};
/* harmony default export */ var business_footer = (BusinessFooter);


/***/ }),

/***/ 22135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62991);



const CSP = __webpack_require__(15331);
function MetaBlock(props) {
    const { title , description , leadImage , children  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Content-Security-Policy",
                content: CSP
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "ZJMu9MsvjHJwPn0kcq31cioCrPxAw0HHWqWOqXpq1-Y"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            leadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: leadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: leadImage
                    })
                ]
            }),
            children
        ]
    });
}


/***/ }),

/***/ 15331:
/***/ (function(module) {

"use strict";
// Used for Staging and Production

const CSP_SETTINGS = {
    "script-src": [
        "'self'",
        "'unsafe-eval'",
        "'unsafe-inline'",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "*.clearpay.com",
        "*.googleapis.com",
        "public.fbot.me",
        "static.fbot.me",
        "campaign.fbot.me",
        "lcx-embed.bambuser.com",
        "www.googletagmanager.com",
        "*.onetrust.com",
        "cdn.branch.io",
        "sc-static.net",
        "snap.licdn.com",
        "connect.facebook.net",
        "munchkin.marketo.net",
        "www.googleadservices.com",
        "cdn.dashhudson.com",
        "djnf6e5yyirys.cloudfront.net",
        "cdn.builder.io",
        "t.contentsquare.net",
        "www.google-analytics.com",
        "googleads.g.doubleclick.net",
        "app.link",
        "v5tufwer.micpn.com",
        "pi.pardot.com",
        "tag.clearbitscripts.com/v1/pk_ba428737ee82fd942f13030da0c2629b/tags.js",
        "tag.rmp.rakuten.com",
        "metadata-static-files.sfo2.cdn.digitaloceanspaces.com/pixel/lp.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/tracking.min.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/destinations.min.js",
        "analytics.tiktok.com/i18n/pixel/events.js",
        "analytics.tiktok.com/i18n/pixel/config.js",
        "analytics.tiktok.com/i18n/pixel/identify.js",
        "bat.bing.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "*.ads-twitter.com",
        "js.adsrvr.org",
        "cdn.bizible.com",
        "analytics.twitter.com",
        "t.co",
        "bat.bing.com",
        "widget.trustpilot.com",
        "www.workwithsquare.com",
        "*.formstack.com",
        "j.6sc.co",
        "www.tiktok.com",
        "sf16-website-login.neutral.ttwstatic.com",
        "ad.doubleclick.net",
        "*.chilipiper.com",
        "*.dreamdata.io",
        "*.dreamdata.cloud"
    ],
    "img-src": [
        "'self'",
        "data:",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "maps.gstatic.com",
        "*.googleapis.com",
        "*.ggpht",
        "cdn.builder.io",
        "static.fbot.me",
        "www.google.co.nz",
        "www.google.co.uk",
        "www.google.com",
        "www.google.com.au",
        "www.googletagmanager.com",
        "px.ads.linkedin.com",
        "www.facebook.com",
        "p.adsymptotic.com",
        "cdn.branch.io",
        "www.google-analytics.com",
        "public.fbot.me",
        "connect.facebook.net",
        "*.onetrust.com",
        "cdn.dashhudson.com",
        "likeshop.me",
        "track.linksynergy.com",
        "consent.linksynergy.com",
        "www.kmart.com.au",
        "www.bigw.com.au/",
        "www.pacsun.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "cdn.bizible.com",
        "*.google.ie",
        "bat.bing.com",
        "t.co",
        "cdn.bizibly.com",
        "cdn.builder.com",
        "b.6sc.co",
        "ad.doubleclick.net",
        "*.google.com"
    ],
    "object-src": [
        "'none'"
    ],
    "base-uri": [
        "'none'"
    ]
};
const CSP = Object.entries(CSP_SETTINGS).reduce((previousValue, param)=>{
    let [key, cspValues] = param;
    const cspString = cspValues.join(" ");
    return "".concat(previousValue, " ").concat(key, " ").concat(cspString, ";");
}, "").trim();
module.exports = CSP;


/***/ }),

/***/ 85704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62991);

function useOnClickOutside(ref, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const listener = (event)=>{
            const el = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        document.addEventListener("click", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
            document.addEventListener("click", listener);
        };
    }, [
        ref,
        handler
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useOnClickOutside);


/***/ }),

/***/ 82090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formSearchBlog":"business-header-autocomplete-list_formSearchBlog__kwAkJ","inputSearch":"business-header-autocomplete-list_inputSearch__gnCxg","clearInput":"business-header-autocomplete-list_clearInput__pxKzP","buttonSearch":"business-header-autocomplete-list_buttonSearch__Xt1EF","formShown":"business-header-autocomplete-list_formShown__JLNRt","suggestionsContainer":"business-header-autocomplete-list_suggestionsContainer__c0WhZ","noSuggestions":"business-header-autocomplete-list_noSuggestions__b5U__","suggestionCategoryTitle":"business-header-autocomplete-list_suggestionCategoryTitle__Uaa_C","suggestionCategoryNoneFound":"business-header-autocomplete-list_suggestionCategoryNoneFound__3OOkC","suggestionCategoryList":"business-header-autocomplete-list_suggestionCategoryList__4_71K","suggestionCategoryListText":"business-header-autocomplete-list_suggestionCategoryListText__qIvPb","suggestionMatch":"business-header-autocomplete-list_suggestionMatch__OyXap","spinnerLoadMore":"business-header-autocomplete-list_spinnerLoadMore__rvXiq","video-spin":"business-header-autocomplete-list_video-spin__1cY8h","clicked":"business-header-autocomplete-list_clicked__YTnNl","show":"business-header-autocomplete-list_show__is_qQ"};

/***/ }),

/***/ 59411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleFooterContainer":"business-footer_articleFooterContainer__xBUa5","articleFooterInner":"business-footer_articleFooterInner__Ss2ro","footerTitle":"business-footer_footerTitle__W_ldb","footerBlock":"business-footer_footerBlock__LW7Gc","footerTop":"business-footer_footerTop__nLgDX","footerBottom":"business-footer_footerBottom__iFotX","footerLocation":"business-footer_footerLocation___OkKA","logoAfterPay":"business-footer_logoAfterPay__mkjQq","themewhite":"business-footer_themewhite__5wy9K"};

/***/ }),

/***/ 68099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"dropdown-selector_dropdownSelector__8Ng7S"};

/***/ })

}]);